export interface ICountry {
  code: string;
  name: string;
  localizedName: string;
  tenantId: string;
  minZipLength: number;
  maxZipLength: number;
  isZipDigitsOnly: boolean | undefined;
}

export interface IRegion {
  countryCode: string;
  regionCode: string;
  regionName: string;
  localizedName: string;
}

export enum TaxIdFormat {
  Brazil = '1',
  Mexico = '2',
  Colombia = '3',
}
